<template>
  <div>
    <div class="row" v-if="labelPosition === 'left'">
      <div class="col-md-4">
        <label
          class="form-control-label"
          :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
        >{{control.label}}</label>
      </div>
      <div class="col-md-8">
        <b-form-select
          v-model="control.value"
          :options="options"
          @change="changed"
          :disabled="control.readonly"
        />
      </div>
    </div>
    <div v-else>
      <label
        class="form-control-label"
        :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
      >{{control.label}}</label>
      <b-form-select
        v-model="control.value"
        :options="options"
        @change="changed"
        :disabled="control.readonly"
      />
    </div>
  </div>
</template>

<script>
import { Hooks } from '@/components/DataGrid/FormBuilder/gui/components/hook_lists'
import Select2Control from '@/components/DataGrid/FormBuilder/third_party_controls/Select2Control'
import Select2MultipleControl from '@/components/DataGrid/FormBuilder/third_party_controls/Select2MultipleControl'
export default {
  name: 'SelectControl',
  components: { Select2MultipleControl, Select2Control },
  props: ['control', 'labelPosition'],
  computed: {
    options() {
      const options = []

      for (let option of this.control.dataOptions) {
        options.push({ text: option.text, value: option.id })
      }

      return options
    },
  },
  methods: {
    changed() {
      const fbInst = this.$instByClass(this, 'form-builder-root')

      fbInst.setRowDataVal(this.control.propName, this.control.value)
    },
  },
}
</script>
